<app-header></app-header>
<app-mobile-sidebar #mobileSidebar></app-mobile-sidebar>
<div class="layout">
    <router-outlet></router-outlet>
</div>
